import React from 'react';

export default function About() {
  return (
    <section id="about" className="container about">
      <h2>About</h2>
      <p>
        Passionate Full Stack / Front-End Developer with hands-on experience in
        building responsive, user-focused web applications. Experienced in using
        React, Node.js, Express, and modern JavaScript frameworks, with strong
        fundamentals in both frontend design and backend logic. Experienced in
        leading development teams, managing projects using Scrum methodologies,
        and delivering efficient solutions from concept to deployment.
      </p>
    </section>
  );
}
